import { render, staticRenderFns } from "./memberFace.vue?vue&type=template&id=5efed3d9&scoped=true"
import script from "./memberFace.vue?vue&type=script&lang=js"
export * from "./memberFace.vue?vue&type=script&lang=js"
import style0 from "./memberFace.vue?vue&type=style&index=0&id=5efed3d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efed3d9",
  null
  
)

export default component.exports